var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCorporatePic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3684 10C20.4383 10 19.6842 10.7429 19.6842 11.6593V17.0519H15.6842C14.754 17.0519 14 17.7947 14 18.7111V38H19.6842V17.0519H23.4737C24.4038 17.0519 25.1579 17.7947 25.1579 18.7111V38H34V11.6593C34 10.7429 33.246 10 32.3158 10H21.3684Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCorporatePic);
export default __webpack_public_path__ + "static/media/defaultCorporatePic.2182379da93e09673d6cf160ff0b6c9e.svg";
export { ForwardRef as ReactComponent };